(() => {
  const root = document.getElementById('ppa-inquiry');
  if (!root) return;
  const params = new URLSearchParams(location.search);
  const field = selector => root.querySelector(selector);
  const displayTitle = value => {
    const clean = value.split(/ BY | By /)[0];
    if (clean !== clean.toUpperCase()) return clean;
    const keep = new Set('I,II,III,IV,V,VI,VII,VIII,IX,X,XI,XII,FS,FSII,3D,2D,NYC,USA,UK,KAWS,LOVE'.split(','));
    return clean.split(' ').map(word => keep.has(word.replace(/[(),.]/g, '')) || word.includes('II.')
      ? word : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
  };
  const title = (params.get('artwork') || '').slice(0, 500);
  const relative = params.get('artwork_url') || '';
  const validPath = /^\/products\/[a-zA-Z0-9_-]+$/.test(relative);
  const topic = field('#inquiry-topic');
  const message = field('#inquiry-message');
  const suggested = {
    availability: 'I’m interested in this work. Please confirm availability, included documentation and delivery options.',
    condition: 'I’m interested in this work. Please share a condition report, additional photographs and details of any restoration.',
    documentation: 'Please tell me which documents accompany this work, including the certificate issuer and available provenance.',
    other: 'My question is: '
  };
  if (params.get('request') === 'condition') topic.value = 'condition';
  let changed = Boolean(message.value.trim());
  if (!changed && (title || validPath)) message.value = params.get('request') === 'similar' ? 'Please suggest available artwork similar to this work.' : suggested[topic.value];
  message.addEventListener('input', () => changed = true);
  topic.addEventListener('change', () => { if (!changed) message.value = suggested[topic.value]; });
  if (title) {
    field('[data-inquiry-title]').value = title;
    field('[data-inquiry-work]').textContent = displayTitle(title);
    field('[data-inquiry-card]').hidden = false;
    field('[data-inquiry-heading]').textContent = 'Let’s talk about this work.';
    field('[data-inquiry-intro]').textContent = 'Your artwork details are already attached. Tell us what you’d like to know.';
  }
  if (!validPath) return;
  const url = new URL(relative, location.origin);
  field('[data-inquiry-url]').value = url.href;
  field('[data-inquiry-back]').href = relative;
  field('[data-inquiry-back]').textContent = '← Back to the artwork';
  url.searchParams.set('view', 'ppa-inquiry-data');
  fetch(url, { credentials: 'same-origin' }).then(response => {
    if (!response.ok) throw new Error('Artwork unavailable');
    return response.json();
  }).then(product => {
    if (product.url !== relative || typeof product.title !== 'string') return;
    field('[data-inquiry-title]').value = product.title;
    field('[data-inquiry-work]').textContent = displayTitle(product.title);
    field('[data-inquiry-artist]').textContent = product.artist;
    field('[data-inquiry-price]').textContent = product.price;
    field('[data-inquiry-price-note]').textContent = /\d/.test(product.price) ? 'Gallery price' : '';
    if (product.image) {
      const image = new URL(product.image, location.origin);
      if (image.protocol === 'https:' && (image.hostname === location.hostname || image.hostname === 'cdn.shopify.com' || image.hostname.endsWith('.myshopify.com'))) {
        field('[data-inquiry-image]').src = image.href;
        field('[data-inquiry-image]').alt = product.alt;
        field('[data-inquiry-image]').hidden = false;
      }
    }
    field('[data-inquiry-card]').hidden = false;
    field('[data-inquiry-heading]').textContent = 'Let’s talk about this work.';
    field('[data-inquiry-intro]').textContent = 'Your artwork details are already attached. Tell us what you’d like to know.';
  }).catch(() => {
    // The submitted artwork title/link remain usable if the image summary cannot load.
  });
})();
